/**
 *
 * @file 组件：企业中心/我的方案/企业方案__企业筛选树
 * @author 张雄伟 <xiongwei_zhang@foxitsoftware.com>
 *
 **/
import React from 'react';
import { Tree } from 'antd';
import { useStoreState } from '&/utils/customHooks';
import { getOrganizationList } from '@/api/personCenter/organization';
import './organizationTree.scss';

function OrganizationTree(props) {
    const { onChange } = props;

    const appStore = useStoreState('appStore'),
        { organization = {} } = appStore,
        { branchId, roleFlag, enterpriseId } = organization;

    const ALL = { key: -1, pid: -2, title: intl.get('base.all') };
    const [treeData, setTreeData] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);

    const onSelect = (_, { node }) => {
        const [key] = selectedKeys,
            newKey = node.key;
        if (key === newKey) return;
        let payload;
        // 部门
        if (node.pid === void 0) {
            payload = {
                entIdAll: undefined,
                entId: +node.enterpriseId,
                searchUserIds: node.memberList?.map(el => el.userId),
            };
        } else if (newKey === -1) {
            // 全部组织
            payload = {
                entIdAll: 1,
                entId: ents.current.map(el => el.id), // 所有总分公司
                searchUserIds: undefined,
            };
        } else if (node.pid > -1) {
            // 单个总、分公司
            payload = {
                entIdAll: undefined,
                entId: +node.key,
                searchUserIds: undefined,
            };
        }
        payload && onChange(payload);
        setSelectedKeys([newKey]);
    };

    const ents = useRef([]);

    const formatTreeData = (list, arr) => {
        for (let i = 0; i < list.length; ) {
            const item = list[i++];
            const { department } = item;
            const children = [];
            department?.length && formatTreeData(department, children);
            arr.push({
                key: item.id,
                title: item.name || item.title,
                children,
                pid: item.pid,
                memberList: item.memberList,
                enterpriseId: item.enterpriseId,
            });
        }
    };

    function getOrganizations() {
        /**
         * @param {int} isAll 企业id，1：获取全部，2：只获取当前公司（默认）
         * @param {int} isMember 是否获取企业中部门成员，0：不获取（默认），1：获取
         * @param {int} isHasScheme 筛选有方案的部门
         **/
        getOrganizationList({ isMember: 1, isHasScheme: 1 }).then(
            ({ data }) => {
                let list = [];
                // 是总管理员且有分公司
                if (roleFlag === 'admin' && data.length > 1) {
                    list = [ALL];
                    setSelectedKeys([ALL.key]);
                    onChange({
                        entIdAll: 1,
                        entId: data.map(el => el.id), // 所有总分公司
                        searchUserIds: undefined,
                    });
                } else {
                    const ID = (branchId || enterpriseId) + '';
                    setSelectedKeys([ID]);
                    onChange({
                        entIdAll: undefined,
                        entId: ID,
                        searchUserIds: undefined,
                    });
                }
                ents.current = data;
                formatTreeData(data, list);
                setTreeData(list);
            }
        );
    }

    useEffect(getOrganizations, []);

    return (
        <Tree
            className="decoration__organization-tree"
            treeData={treeData}
            selectedKeys={selectedKeys}
            blockNode
            onSelect={onSelect}
        />
    );
}

export default OrganizationTree;
